import axios from "axios";
import environment from "src/environment/environment";
import { IUnitConverterRequestResponse } from "src/models/unitConverter.model";
import { IVolumetricWeightRequest } from "src/models/volumetricWeight.models";
import { ConvertTypeEnum } from "src/shared/enum";

export class ToolsService {

    static baseUrl = environment.apiGateway.apiUrl;
    
    /**
	 * Calculate the volumetric weight using the tool's GetVolumetricWeight API
	 * @param data
	 */
    public static async getVolumetricWeight(data: IVolumetricWeightRequest) {
        try {
            const params = {
                length: data.length,
                width: data.width,
                height: data.height,
                dimensionUnit: data.dimensionUnit,
                carrier: data.carrier,
                service: data.service
            };
            const url = this.baseUrl + 'tools/volumetric-weight';
            const res = await axios.get(url, { params });
			return res;
        } catch (error: any) {
			let err;
			if (error.response) {
				err = error.response.data;
			} else {
				err = {
					error: 'Invalid request',
				};
			}
			throw err.error;
		}
    }

	/**
	 * Get unitConverter
	 */
	public static async getConvertedUnit(convertType:ConvertTypeEnum, data: IUnitConverterRequestResponse) {
		try {
			const params = {
				sourceValue: data.sourceValue,
				sourceUnit: data.sourceUnit,
				finalUnit: data.finalUnit
			};
			const url = `${this.baseUrl + 'tools/unit-converter'}/${convertType}`;
			const res = await axios.get(url, { params });
			return res;
		} catch (error: any) {
			let err;
			if (error.response) {
				err = error.response.data;
			} else {
				err = {
					error: 'Invalid request',
				};
			}
			throw err.error;
		}
	}
}